import React, { useCallback, useMemo, useState } from 'react';
import Paper from "@material-ui/core/Paper";
import TreeView from "@material-ui/lab/TreeView";
import type { FC, ChangeEvent } from 'react';
import AddBoxOutlinedIcon from "../../../../../../../../../icons/OpenTree";
import RemoveOutlinedIcon from "../../../../../../../../../icons/CloseTree";
import {useStyles} from './Tree.styles'
import {TreeItem} from './TreeItem'
import type { ITreeProps } from './Tree.types';
import { Hierarchy } from '../../../../../../../../common';

export const Tree: FC<ITreeProps> = props => {
  const classes = useStyles();
  const {hierarchies, onToggleItem, expandedAll, selected, isEmpty} = props;
  const [expanded, setExpanded] = useState<string[]>([]);

  const flatHierarchyItems = useMemo(()=> Hierarchy.flat(hierarchies), [hierarchies]) ;

  const handleNodeSelect = useCallback((e: ChangeEvent<{}>, nodeIds: string[]) => {
    const hierarchyItem = flatHierarchyItems.find(it => nodeIds.includes(String(it.id)));
    if (hierarchyItem?.children.length === 0) {
      onToggleItem?.(hierarchyItem.origin.id);
    }
  }, [flatHierarchyItems, onToggleItem]);

  const finalExpanded = expandedAll ? flatHierarchyItems.map(h => String(h.id)) : expanded;
  const handleNodeToggle = useCallback((e: ChangeEvent<{}>, nodeIds: string[]) => {
    setExpanded(nodeIds)
  }, [setExpanded]);

  return (
    <Paper className={classes.paper}>
      <TreeView
        defaultCollapseIcon={<RemoveOutlinedIcon />}
        defaultExpandIcon={<AddBoxOutlinedIcon />}
        expanded={finalExpanded}
        role="list"
        selected={selected.map(String)}
        multiSelect
        onNodeSelect={handleNodeSelect}
        onNodeToggle={handleNodeToggle}
      >
        {isEmpty ? "No results" : null}
        {hierarchies.map(hierarchy => <TreeItem key={hierarchy.id} hierarchy={hierarchy} onSelect={onToggleItem} />)}
      </TreeView>
    </Paper>
  );
}